<script>
// Main Components
import Layout from '@/router/layouts/main';
import Grid from './components/grid.vue';

export default {
  page: {
    title: 'CategoryTypes',
  },
  components: {
    Layout,
    Grid,
  },
  computed: {
    fieldsComputed() {
      return [
        {
          key: 'name',
          label: this.$t('general.name'),
          sortable: true,
        },
        {
          key: 'consumptionStepName',
          label: this.$t('categories.consumptionStep'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'referenceDate',
          label: this.$t('general.referenceDate'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'leadTime',
          label: this.$t('general.leadTime'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'edit',
          label: this.$t('general.edit'),
          class: 'centered-field',
          sortable: true,
        },
      ];
    },
  },
};
</script>

<template>
  <Layout :title="$t('categories.categoryTypes')">
    <Grid :fields="fieldsComputed" />
  </Layout>
</template>
